import React from "react";
import {get, post} from '../../utils/api';
import './Vertical.css';
import VertModal from '../Modal/Vertical';
import Loading from "../Shared/Loading";
import editIcon from "../../assets/edit-icon.svg";
import SVG from "react-inlinesvg";

class Vertical extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            verticals: {},
            record: {},
            // functionality: {},
            showModal: false,
            loading: true,
            action: false,
        };
        this.openModal = this.openModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.refreshVerticals = this.refreshVerticals.bind(this);
        this.setLoading = this.setLoading.bind(this);
    }
    componentDidMount() {
        this.refreshVerticals();
    };
    setLoading(loading) {
        this.setState({
            loading: loading
        })
    }
    refreshVerticals() {
        return get('manage/verticals')
            .then((res) => {
                this.setState({
                    verticals: res,
                    loading: false,
                })
            })
    }
    openModal(record, action) {
        this.setState({
            record: record,
            action: action,
            showModal: true
        })
    }
    toggleModal(show) {
        this.setState({
            showModal: show
        })
    }
    render() {
        let editI = (<span className="f-edit"><SVG src={editIcon}/></span>);
        let verticals = this.state.verticals;
        return (
            <React.Fragment>
                {this.state.showModal &&
                <VertModal record={this.state.record}
                           action={this.state.action}
                           refreshVerticals={this.refreshVerticals}
                           setLoading={this.setLoading}
                           toggleModal={this.toggleModal}/>
                }
                <div id="vertical-page-container">
                    <div className="vertical-header"><h1 className="uppercase">Verticals</h1> <button className="f-button-create button button--grey v-create-btn " onClick={() => this.openModal({}, 'create')}>Create</button></div>
                    {this.state.loading ? <Loading/> :
                        <ul id="vertical-list">
                            {verticals.map((v, key)=> (
                                <li key={key} onClick={() => this.openModal(v, 'update')}>{v.name}       {editI}</li>
                            ))}
                        </ul>
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default Vertical;

